import { isEmpty } from 'lodash/fp';
import { PRODUCT_TYPE } from '@ahmdigital/constants';
// @ts-expect-error - Automatic, Please fix when editing this file
import getEligibleRewards from '@ahmdigital/offers/lib/model/offer/get-eligible-rewards';
import getPresaleSentence, { UPSELL_TYPE } from '@ahmdigital/logic/lib/content/offers/qualified/get-presale-sentence';
// @ts-expect-error - Automatic, Please fix when editing this file
import getRestrictedUpsellRewards from '@ahmdigital/offers/lib/model/offer/get-restricted-upsell-rewards';
// @ts-expect-error - Automatic, Please fix when editing this file
import getUpsellApplicableRewards from '@ahmdigital/offers/lib/model/offer/get-upsell-applicable-rewards';

import getIsEveryUpsellRewardRestricted from '../../../logic/get-is-every-upsell-reward-restricted';

const PRODUCT_TYPE_TO_UPSELL_TYPE_MAP = {
  [PRODUCT_TYPE.EXTRAS]: UPSELL_TYPE.HOSPITAL,
  [PRODUCT_TYPE.HOSPITAL]: UPSELL_TYPE.EXTRAS,
};

// @ts-expect-error - Automatic, Please fix when editing this file
const getEligibleSentence = (offer, scenario) => {
  const eligibleRewards = getEligibleRewards(offer, scenario);
  if (isEmpty(eligibleRewards)) {
    return null;
  }
  // @ts-expect-error - Automatic, Please fix when editing this file
  return getPresaleSentence({ offer, rewards: eligibleRewards });
};

// @ts-expect-error - Automatic, Please fix when editing this file
const getUpsellSentence = (offer, scenario, product) => {
  const upsellApplicableRewards = getUpsellApplicableRewards(offer, scenario);
  if (isEmpty(upsellApplicableRewards)) {
    return null;
  }

  const productType = product?.type;
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ extras: string; hospital: string; }'.
  const upsellType = PRODUCT_TYPE_TO_UPSELL_TYPE_MAP[productType];
  if (!upsellType) {
    return null;
  }
  const restrictedUpsellRewards = getRestrictedUpsellRewards(offer, scenario);
  const isEveryRewardRestricted = getIsEveryUpsellRewardRestricted({
    restrictedUpsellRewards,
    upsellApplicableRewards,
  });
  return getPresaleSentence({
    isRestricted: isEveryRewardRestricted,
    offer,
    rewards: upsellApplicableRewards,
    upsell: upsellType,
  });
};

// @ts-expect-error - Automatic, Please fix when editing this file
const generatePresaleSentence = (offer, { product, scale } = {}) => {
  const productId = product?.id;
  const scenario = { productId, scale };
  return getEligibleSentence(offer, scenario) || getUpsellSentence(offer, scenario, product);
};

export default generatePresaleSentence;
